module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "titleList": _vm.titleList,
      "tabs": _vm.tabs,
      "treeData": _vm.treeData,
      "defaultPersonList": _vm.defaultPersonList,
      "activeName": _vm.tabActive,
      "defaultPersonListChecked": _vm.defaultPersonListChecked,
      "showCheckBox": _vm.showCheckBox,
      "personList": _vm.personList,
      "filterText": _vm.filterText
    }
  }, [_c('tabs', {
    attrs: {
      "activeName": _vm.tabActive
    },
    on: {
      "tabChange": _vm.tabChange
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('el-tab-pane', {
      key: tab.name,
      attrs: {
        "label": tab.label,
        "name": tab.name
      }
    }, [(_vm.isPerson == '0') ? _c('collapse', {
      attrs: {
        "sCollActiveName": _vm.catalogSubType
      },
      on: {
        "changeColl": _vm.changeColl
      }
    }, [_c('div', {
      staticStyle: {
        "height": "40px"
      }
    }, [_c('radius-input', {
      on: {
        "searchClick": _vm.searchClick
      }
    })], 1), _vm._v(" "), _vm._l((_vm.titleList), function(item, index) {
      return _c('el-collapse-item', {
        key: index,
        attrs: {
          "title": item.title,
          "name": item.name
        }
      }, [_c('tree', {
        attrs: {
          "defaultChecked": _vm.defaultChecked,
          "showCheckBox": _vm.showCheckBox,
          "filterText": _vm.filterText,
          "data": _vm.treeData
        },
        on: {
          "checkTree": _vm.checkTree,
          "treeNodeClick": _vm.treeNodeClick
        }
      })], 1)
    })], 2) : _vm._e(), _vm._v(" "), (_vm.isPerson == '1') ? _c('div', {
      staticClass: " coll"
    }, [_c('div', {
      staticClass: "searchWidth",
      staticStyle: {
        "height": "40px",
        "width": "85%",
        "display": "inline-block"
      }
    }, [_c('radius-input', {
      on: {
        "searchClick": _vm.searchClick
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "40px",
        "width": "40px",
        "display": "inline-block",
        "float": "right"
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-plus",
      staticStyle: {
        "font-size": "20px",
        "cursor": "pointer",
        "margin-top": "2px"
      },
      on: {
        "click": _vm.addPersonList
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "person_medical_record_list_content"
    }, [(_vm.showCheckBox) ? _c('el-checkbox-group', {
      model: {
        value: (_vm.personChecked),
        callback: function($$v) {
          _vm.personChecked = $$v
        },
        expression: "personChecked"
      }
    }, _vm._l((_vm.personList), function(item) {
      return _c('el-checkbox', {
        key: item.id,
        staticStyle: {
          "width": "100%",
          "margin-left": "0",
          "text-indent": "10px"
        },
        attrs: {
          "label": item.id
        }
      }, [_c('p', {
        staticClass: "checkbox_list person_medical_record_list",
        staticStyle: {
          "text-indent": "0"
        },
        attrs: {
          "title": item.catalogName
        }
      }, [_c('span', [_vm._v(_vm._s(item.catalogName))]), _vm._v(" "), _c('i', {
        staticClass: "del_medical",
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.delPerson(item)
          }
        }
      }, [_vm._v("删除")])])])
    }), 1) : _vm._l((_vm.personList), function(item, index) {
      return _c('p', {
        key: item.id,
        staticClass: "person-item person_medical_record_list",
        class: {
          isActive: index === _vm.i
        },
        attrs: {
          "title": item.catalogName
        },
        on: {
          "click": function($event) {
            return _vm.personClick(item, index)
          }
        }
      }, [_c('span', {
        staticClass: "person-item-span"
      }, [_vm._v(_vm._s(item.catalogName))]), _vm._v(" "), _c('i', {
        staticClass: "del_medical",
        on: {
          "click": function($event) {
            return _vm.delPerson(item)
          }
        }
      }, [_vm._v("删除")])])
    })], 2)]) : _vm._e()], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7efc1e36","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/collapseMedicalRecord/collapseMedicalRecord.vue
// module id = 584
// module chunks = 1 2 3 4 5 6 7 8